import {Checkbox} from "./filters/Checkbox";
import {MultiSelect} from "./filters/MultiSelect";
import {MultiSelect_Typeahead} from "./filters/MultiSelect-Typeahead";
import {DateWindow} from "./filters/dateWindow/DateWindow";
import {TextSearch} from "./filters/TextSearch";

export enum FilterTypes {
    Checkbox = "checkbox",
    MultiSelect = "multiselect",
    MultiSelect_Typeahead = "multiselect_typeahead",
    DateWindow = "dateWindow",
    Freetext_Search = "freetext_search"
}

export const FilterTypeComponentMap: Record<FilterTypes, any> = {
    [FilterTypes.Checkbox]: Checkbox,
    [FilterTypes.MultiSelect]: MultiSelect,
    [FilterTypes.MultiSelect_Typeahead]: MultiSelect_Typeahead,
    [FilterTypes.DateWindow]: DateWindow,
    [FilterTypes.Freetext_Search]: TextSearch
};